import { motion, useReducedMotion } from 'framer-motion'
import { Section } from '@/components/ui/Section'
import { Container } from '@/components/ui/Container'
import { DecoratedHeader } from '@/components/ui/DecoratedHeader'
import { smoothEase } from '@/lib/motion'

const INTERIOR_SHOTS = [
  {
    src: '/interior/1.jpg',
    width: 736,
    height: 817,
    alt: 'Rodeo Nails salon interior, warm lighting and seating area',
  },
  {
    src: '/interior/2.jpg',
    width: 1200,
    height: 1680,
    alt: 'Rodeo Nails salon interior, treatment area and calm beige tones',
  },
  {
    src: '/interior/3.jpg',
    width: 736,
    height: 1308,
    alt: 'Rodeo Nails salon interior, detail of the space and finishes',
  },
  {
    src: '/interior/4.jpg',
    width: 736,
    height: 736,
    alt: 'Rodeo Nails salon interior, bright airy view of the nail studio',
  },
  {
    src: '/interior/5.jpg',
    width: 736,
    height: 736,
    alt: 'Rodeo Nails salon interior, workstations and refined decor',
  },
] as const

export function HomeInteriorShowcase() {
  const reduced = useReducedMotion()
  return (
    <Section className="bg-sage-wash/35">
      <Container>
        <DecoratedHeader
          size="section"
          eyebrow="The"
          eyebrowAccent="Space"
          title="Inside the salon"
          description="You notice the room before polish hits your nail: chairs that feel good to sit in, stations we keep tidy, lighting that is easy on the eyes."
          sparkle={false}
        />
        <div className="mt-10 grid gap-3 sm:grid-cols-2 sm:gap-4 md:grid-cols-3">
          {INTERIOR_SHOTS.map((shot, i) => (
            <motion.figure
              key={shot.src}
              initial={reduced ? false : { opacity: 0, y: 16 }}
              whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{
                duration: reduced ? 0 : 0.5,
                delay: reduced ? 0 : i * 0.08,
                ease: smoothEase,
              }}
              className="m-0 overflow-hidden rounded-[var(--radius-button)]"
            >
              <div className="relative aspect-[4/3] w-full">
                <img
                  src={shot.src}
                  alt={shot.alt}
                  width={shot.width}
                  height={shot.height}
                  loading={i === 0 ? 'eager' : 'lazy'}
                  decoding="async"
                  fetchPriority={i === 0 ? 'high' : 'low'}
                  sizes="(max-width: 767px) 100vw, 33vw"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
            </motion.figure>
          ))}
        </div>
      </Container>
    </Section>
  )
}
